<div class="crud-table ibc-border-table table-input-field">
  <mat-table [dataSource]="crudTableDataSource">
    <mat-header-row
      *matHeaderRowDef="tableDisplayedColumns"
      class="ibc-body-text-large-bold"></mat-header-row>

    <ng-container>
      <mat-row *matRowDef="let row; columns: tableDisplayedColumns"></mat-row>
    </ng-container>

    <ng-container matColumnDef="select">
      <mat-header-cell *matHeaderCellDef>
        <mat-checkbox
          (change)="$event ? toggleAllRows() : null"
          [checked]="selection.hasValue() && isAllSelected()"
          [indeterminate]="selection.hasValue() && !isAllSelected()"
          [disabled]="checkForEnableOrDisable()">
        </mat-checkbox>
      </mat-header-cell>
      <mat-cell *matCellDef="let row; let i = index">
        <mat-checkbox
          *ngIf="
            !tableService.rowContainsInput(row) &&
            (i > 0 || (i === 0 && pageMode !== 'Add'))
          "
          (change)="
            $event.checked ? checked(row) : unchecked(row);
            emitCreateSelectionChange()
          "
          [checked]="isChecked(row)"
          (keydown)="$event.stopPropagation()">
        </mat-checkbox>
      </mat-cell>
    </ng-container>

    <form [formGroup]="crudTableForm">
      <ng-container
        *ngFor="let item of customiseCrudTableColumns; let i = index"
        [matColumnDef]="item.key">
        <mat-header-cell *matHeaderCellDef [ngStyle]="getColumnStyle(item.key)">
          <span class="column-header cursor">
            <span class="ibc-body-text-large">{{ item.label }}</span>
          </span>
        </mat-header-cell>
        <mat-cell *matCellDef="let element" [ngStyle]="getColumnStyle(item.key)">
          @if (element.isInputRow && getFieldConfig(item.key)) {
            <app-field-renderer
              [config]="getFieldConfig(item.key)!"
              [control]="$any(crudTableForm.get(item.key))"
              [formGroup]="crudTableForm"
              [row]="element"
              [rowIndex]="i"
              (valueChange)="onFieldRendererValueChange()">
            </app-field-renderer>
          }

          @if (!(element.isInputRow && getFieldConfig(item.key))) {
            <ng-container *ngIf="element.isInputRow; else inputRow">
              <span
                class="ibc-body-text-medium {{
                  detectHyperlink(item.key, element.isInputRow, element)
                    ? 'text-hyperlink'
                    : ''
                }} {{
                  item.key === formFields.attachments
                    ? 'attachment-cell-ellipsis'
                    : ''
                }}"
                tabindex="-1"
                *ngIf="getValueField(item.key)"
                [matTooltip]="
                  item.key === formFields.attachments
                    ? getAttachmentCellTooltip(element)
                    : ''
                "
                [matTooltipDisabled]="
                  item.key !== formFields.attachments ||
                  !getAttachmentCellTooltip(element)
                "
                (click)="
                  handleHyperlinkClickEvent(
                    item.key,
                    element,
                    i,
                    element.isInputRow
                  )
                "
                (keydown)="$event.stopPropagation()">
                {{ element[item.key] }}
              </span>
            <ng-container
              *ngIf="item.key === 'dimLWH' && !getValueField(item.key)">
              <div class="dimension-dimLWH">
                <mat-form-field
                  appearance="outline"
                  class="mat-sm dimLWH dimension dim-length">
                  <input
                    matInput
                    [formControlName]="'dimL'"
                    [name]="item.key"
                    autocomplete="off"
                    (blur)="basicInputOnChanges()" />
                  <app-svg-icon
                    *ngIf="
                      commonService.checkControlError(crudTableForm, 'dimL')
                    "
                    matSuffix
                    [iconName]="'infoCircle'"
                    [isStaticSvg]="true"
                    [isFrom]="'Page'"
                    class="cursor"
                    (click)="fetchWidth($event, 'dimL')"
                    (keydown)="$event.stopPropagation()"></app-svg-icon>
                  <app-custom-error-tooltip
                    *ngIf="
                      commonService.checkControlError(crudTableForm, 'dimL') &&
                      setCrudTableErrorTooltip['dimL']
                    "
                    [tooltipWidth]="setCrudTableWidth['dimL']"
                    [tooltipText]="getErrorMessage('dimL')"
                    (tooltipCloseClicked)="
                      commonService.closeErrorTooltip(
                        'dimL',
                        setCrudTableErrorTooltip
                      )
                    ">
                  </app-custom-error-tooltip>
                </mat-form-field>
                <span>-</span>
                <mat-form-field
                  appearance="outline"
                  class="mat-sm dimension dimLWH dim-width">
                  <input
                    matInput
                    [formControlName]="'dimW'"
                    [name]="item.key"
                    autocomplete="off"
                    (blur)="basicInputOnChanges()" />
                  <app-svg-icon
                    *ngIf="
                      commonService.checkControlError(crudTableForm, 'dimW')
                    "
                    matSuffix
                    [iconName]="'infoCircle'"
                    [isStaticSvg]="true"
                    [isFrom]="'Page'"
                    class="cursor"
                    (click)="fetchWidth($event, 'dimW')"
                    (keydown)="$event.stopPropagation()"></app-svg-icon>
                  <app-custom-error-tooltip
                    *ngIf="
                      commonService.checkControlError(crudTableForm, 'dimW') &&
                      setCrudTableErrorTooltip['dimW']
                    "
                    [tooltipWidth]="setCrudTableWidth['dimW']"
                    [tooltipText]="getErrorMessage('dimW')"
                    (tooltipCloseClicked)="
                      commonService.closeErrorTooltip(
                        'dimW',
                        setCrudTableErrorTooltip
                      )
                    ">
                  </app-custom-error-tooltip>
                </mat-form-field>
                <span>-</span>
                <mat-form-field
                  appearance="outline"
                  class="mat-sm dimension dimLWH dim-height">
                  <input
                    matInput
                    [formControlName]="'dimH'"
                    [name]="item.key"
                    autocomplete="off"
                    (blur)="basicInputOnChanges()" />
                  <app-svg-icon
                    *ngIf="
                      commonService.checkControlError(crudTableForm, 'dimH')
                    "
                    matSuffix
                    [iconName]="'infoCircle'"
                    [isStaticSvg]="true"
                    [isFrom]="'Page'"
                    class="cursor"
                    (click)="fetchWidth($event, 'dimH')"
                    (keydown)="$event.stopPropagation()"></app-svg-icon>
                  <app-custom-error-tooltip
                    *ngIf="
                      commonService.checkControlError(crudTableForm, 'dimH') &&
                      setCrudTableErrorTooltip['dimH']
                    "
                    [tooltipWidth]="setCrudTableWidth['dimH']"
                    [tooltipText]="getErrorMessage('dimH')"
                    (tooltipCloseClicked)="
                      commonService.closeErrorTooltip(
                        'dimH',
                        setCrudTableErrorTooltip
                      )
                    ">
                  </app-custom-error-tooltip>
                </mat-form-field>
              </div>
            </ng-container>
            <ng-container
              *ngIf="item.key === 'shipmentValue' && !getValueField(item.key)">
              <div class="min-max-container">
                <mat-form-field
                  appearance="outline"
                  class="mat-sm min-max-field">
                  <mat-label>Minimum</mat-label>
                  <input
                    matInput
                    [formControlName]="'shipmentValueMin'"
                    [name]="item.key"
                    autocomplete="off"
                    (change)="onFieldValueChanges('shipmentValueMin')" />
                    <app-svg-icon
                    *ngIf="commonService.checkControlError(crudTableForm, 'shipmentValueMin')"
                    matSuffix
                    [iconName]="'infoCircle'"
                    [isStaticSvg]="true"
                    [isFrom]="'Page'"
                    class="cursor info-icon-error"
                    (click)="fetchWidth($event, 'shipmentValueMin')"
                    (keydown)="$event.stopPropagation()"></app-svg-icon>
                  <app-custom-error-tooltip
                    *ngIf="
                      commonService.checkControlError(crudTableForm, 'shipmentValueMin') &&
                      setCrudTableErrorTooltip['shipmentValueMin']
                    "
                    [tooltipWidth]="setCrudTableWidth['shipmentValueMin']"
                    [tooltipText]="getErrorMessage('shipmentValueMin')"
                    (tooltipCloseClicked)="
                      commonService.closeErrorTooltip(
                        'shipmentValueMin',
                        setCrudTableErrorTooltip
                      )
                    ">
                  </app-custom-error-tooltip>
                </mat-form-field>
                <span class="separator">-</span>
                <mat-form-field
                  appearance="outline"
                  class="mat-sm min-max-field">
                  <mat-label>Maximum</mat-label>
                  <input
                    matInput
                    [formControlName]="'shipmentValueMax'"
                    [name]="item.key"
                    placeholder="Maximum"
                    autocomplete="off"
                    (change)="onFieldValueChanges('shipmentValueMax')" />
                </mat-form-field>
              </div>
            </ng-container>
            <ng-container
              *ngIf="item.key === 'shipmentWeight' && !getValueField(item.key)">
              <div class="min-max-container">
                <mat-form-field
                  appearance="outline"
                  class="mat-sm min-max-field">
                  <mat-label>Minimum</mat-label>
                  <input
                    matInput
                    [formControlName]="'shipmentWeightMin'"
                    [name]="item.key"
                    autocomplete="off"
                    (change)="onFieldValueChanges('shipmentWeightMin')" />
                    <app-svg-icon
                    *ngIf="commonService.checkControlError(crudTableForm, 'shipmentWeightMin')"
                    matSuffix
                    [iconName]="'infoCircle'"
                    [isStaticSvg]="true"
                    [isFrom]="'Page'"
                    class="cursor info-icon-error"
                    (click)="fetchWidth($event, 'shipmentWeightMin')"
                    (keydown)="$event.stopPropagation()"></app-svg-icon>
                  <app-custom-error-tooltip
                    *ngIf="
                      commonService.checkControlError(crudTableForm, 'shipmentWeightMin') &&
                      setCrudTableErrorTooltip['shipmentWeightMin']
                    "
                    [tooltipWidth]="setCrudTableWidth['shipmentWeightMin']"
                    [tooltipText]="getErrorMessage('shipmentWeightMin')"
                    (tooltipCloseClicked)="
                      commonService.closeErrorTooltip(
                        'shipmentWeightMin',
                        setCrudTableErrorTooltip
                      )
                    ">
                  </app-custom-error-tooltip>
                </mat-form-field>
                <span class="separator">-</span>
                <mat-form-field
                  appearance="outline"
                  class="mat-sm min-max-field">
                  <mat-label>Maximum</mat-label>
                  <input
                    matInput
                    [formControlName]="'shipmentWeightMax'"
                    [name]="item.key"
                    autocomplete="off"
                    (change)="onFieldValueChanges('shipmentWeightMax')" />
                </mat-form-field>
              </div>
            </ng-container>
            <!-- Generic autocomplete fields -->
            <mat-form-field
              appearance="outline"
              class="mat-sm mat-form-field-disabled"
              *ngIf="
                getAutocompleteFields(item.key) && !getValueField(item.key)
              ">
              <mat-icon
                matPrefix
                class="dropdown-icon"
                *ngIf="item.key === formFields.codeAndDescription"
                >{{ actionIcons.keyboardDownArrow }}
              </mat-icon>
              <input
                matInput
                [formControlName]="item.key"
                [matAutocomplete]="autoCompleteDropdown"
                (input)="formAutocompleteValueChanges(item.key)"
                [attr.id]="'autocomplete-' + item.key"
                [attr.data-field-type]="item.key"
                #focusAirlineCode />
              <mat-autocomplete
                #autoCompleteDropdown="matAutocomplete"
                (keydown)="$event.stopPropagation()"
                (optionSelected)="onOptionSelectedFormChanges(item.key)">
                <mat-option
                  *ngFor="
                    let data of getAutocompleteOptionsList(item.key) | async
                  "
                  [value]="data.name">
                  {{ data.name }}
                </mat-option>
              </mat-autocomplete>
              <app-field-clear-suffix
                matSuffix
                [large]="false"
                [control]="crudTableForm.get(item.key)"
                [autocomplete]="true"
                (cleared)="onAutocompleteFieldCleared(item.key)" />
              <app-svg-icon
                *ngIf="commonService.checkControlError(crudTableForm, item.key)"
                matSuffix
                [iconName]="'infoCircle'"
                [isStaticSvg]="true"
                [isFrom]="'Page'"
                class="cursor info-icon-error"
                (click)="fetchWidth($event, item.key)"
                (keydown)="$event.stopPropagation()"></app-svg-icon>
              <app-custom-error-tooltip
                *ngIf="
                  commonService.checkControlError(crudTableForm, item.key) &&
                  setCrudTableErrorTooltip[item.key]
                "
                [tooltipWidth]="setCrudTableWidth[item.key]"
                [tooltipText]="getErrorMessage(item.key)"
                (tooltipCloseClicked)="
                  commonService.closeErrorTooltip(
                    item.key,
                    setCrudTableErrorTooltip
                  )
                ">
              </app-custom-error-tooltip>
            </mat-form-field>
            <mat-form-field
              appearance="outline"
              class="mat-sm"
              *ngIf="getInputFormControl(item.key) && !getValueField(item.key)">
              <input
                appTrimInput
                *ngIf="getBasicInputControl(item.key)"
                matInput
                [formControlName]="item.key"
                [attr.data-field-type]="item.key"
                #firstInput
                (input)="basicInputOnChanges(item.key)"
                (blur)="onInvoiceNumberBlur(item.key)" />
              <input
                *ngIf="getInputControlWithAlphaNumbersHyphen(item.key)"
                matInput
                [formControlName]="item.key"
                [attr.data-field-type]="item.key"
                (blur)="onBlurCrudTableInput()" />
              <input
                *ngIf="
                  getInputControlWithAlphaNumbers(item.key) &&
                  isFrom === 'Mawb-Flight' &&
                  item.key === 'flightNumber'
                "
                matInput
                appUppercase
                [formControlName]="item.key"
                [attr.data-field-type]="item.key"
                (blur)="onBlurFlightNumber()"
                [appAlphabetsWithNumbers]="3" />
              <input
                *ngIf="isFrom === 'Mawb-Flight' && item.key === 'mawbPart'"
                matInput
                appValidAlphabets
                [formControlName]="item.key"
                [attr.data-field-type]="item.key"
                (blur)="onBlurCrudTableInput()" />
              <input
                *ngIf="
                  getInputControlWithAlphaNumbers(item.key) &&
                  isFrom != 'Mawb-Flight' &&
                  item.key != 'flightNumber'
                "
                matInput
                [formControlName]="item.key"
                [attr.data-field-type]="item.key"
                (blur)="onBlurCrudTableInput()"
                [appAlphabetsWithNumbers]="2" />
              <input
                *ngIf="getInputControlWithDecimal(item.key)"
                matInput
                [formControlName]="item.key"
                [attr.data-field-type]="item.key"
                (blur)="onBlurCrudTableInput()"
                [appDigitWithTwoDecimalNumber]="
                  item.key === 'weight'
                    ? 9
                    : item.key === 'incomingChargeAmount' ||
                        item.key === 'chargeAmount'
                      ? 10
                      : 7
                " />
              <input
                *ngIf="getInputControlWithNumbers(item.key)"
                matInput
                [formControlName]="item.key"
                [attr.data-field-type]="item.key"
                (blur)="onBlurCrudTableInput()" />
              <app-svg-icon
                *ngIf="commonService.checkControlError(crudTableForm, item.key)"
                matSuffix
                [iconName]="'infoCircle'"
                [isStaticSvg]="true"
                [isFrom]="'Page'"
                class="cursor info-icon-error"
                (click)="fetchWidth($event, item.key)"
                (keydown)="$event.stopPropagation()"></app-svg-icon>
              <app-custom-error-tooltip
                *ngIf="
                  commonService.checkControlError(crudTableForm, item.key) &&
                  setCrudTableErrorTooltip[item.key]
                "
                [tooltipWidth]="setCrudTableWidth[item.key]"
                [tooltipText]="getErrorMessage(item.key)"
                (tooltipCloseClicked)="
                  commonService.closeErrorTooltip(
                    item.key,
                    setCrudTableErrorTooltip
                  )
                ">
              </app-custom-error-tooltip>
            </mat-form-field>
            @if (item.key === 'arrivalDate' || item.key === 'invoiceDate') {
              <mat-form-field
                appearance="outline"
                class="mat-sm"
                *ngIf="
                  (item.key === 'arrivalDate' || item.key === 'invoiceDate') &&
                  !getValueField(item.key)
                ">
                <input
                  (click)="picker.open()"
                  (focus)="picker.open()"
                  matInput
                  [matDatepicker]="picker"
                  [formControlName]="item.key"
                  [min]="minDate"
                  [max]="maxDate"
                  (dateChange)="onBlurCrudTableInput()" />
                <mat-datepicker
                  #picker
                  (closed)="datePickerclose('arrivalDate')"></mat-datepicker>
                <app-svg-icon
                  *ngIf="
                    commonService.checkControlError(crudTableForm, item.key)
                  "
                  matSuffix
                  [iconName]="'infoCircle'"
                  [isStaticSvg]="true"
                  [isFrom]="'Page'"
                  class="cursor"
                  (click)="
                    fetchWidth($event, item.key); $event.stopPropagation()
                  "
                  (keydown)="$event.stopPropagation()"></app-svg-icon>
                <app-custom-error-tooltip
                  *ngIf="
                    commonService.checkControlError(crudTableForm, item.key) &&
                    setCrudTableErrorTooltip[item.key]
                  "
                  [tooltipWidth]="setCrudTableWidth[item.key]"
                  [tooltipText]="getErrorMessage(item.key)"
                  (tooltipCloseClicked)="
                    commonService.closeErrorTooltip(
                      item.key,
                      setCrudTableErrorTooltip
                    )
                  ">
                </app-custom-error-tooltip>
              </mat-form-field>
            }
            @if (
              timeZones &&
              timeZones.length > 0 &&
              item.key === formFields.dateTimeAndTimezone
            ) {
              <mat-form-field
                appearance="outline"
                class="mat-sm"
                *ngIf="!getValueField(item.key)">
                <app-date-time-picker
                  formControlName="dateTimeAndTimezone"
                  [timeZones]="timeZones">
                </app-date-time-picker>
                <app-svg-icon
                  *ngIf="
                    commonService.checkControlError(crudTableForm, item.key)
                  "
                  matSuffix
                  [iconName]="'infoCircle'"
                  [isStaticSvg]="true"
                  [isFrom]="'Page'"
                  class="cursor"
                  (click)="
                    fetchWidth($event, item.key); $event.stopPropagation()
                  "
                  (keydown)="$event.stopPropagation()"></app-svg-icon>
                <app-custom-error-tooltip
                  *ngIf="
                    commonService.checkControlError(crudTableForm, item.key) &&
                    setCrudTableErrorTooltip[item.key]
                  "
                  [tooltipWidth]="setCrudTableWidth[item.key]"
                  [tooltipText]="getErrorMessage(item.key)"
                  (tooltipCloseClicked)="
                    commonService.closeErrorTooltip(
                      item.key,
                      setCrudTableErrorTooltip
                    )
                  ">
                </app-custom-error-tooltip>
              </mat-form-field>
            }
            </ng-container>
            <ng-template #inputRow>
              <span
                *ngIf="item.key !== 'shipmentValue' && item.key !== 'shipmentWeight'"
                class="ibc-body-text-medium {{
                  detectHyperlink(item.key, false, element) ? 'text-hyperlink' : ''
                }} {{
                  item.key === formFields.attachments
                    ? 'attachment-cell-ellipsis'
                    : ''
                }}"
                tabindex="-1"
                [matTooltip]="
                  item.key === formFields.attachments
                    ? getAttachmentCellTooltip(element)
                    : ''
                "
                [matTooltipDisabled]="
                  item.key !== formFields.attachments ||
                  !getAttachmentCellTooltip(element)
                "
                (click)="handleHyperlinkClickEvent(item.key, element, i)"
                (keydown)="$event.stopPropagation()">
                {{ element[item.key] }}
              </span>
              <span
                *ngIf="item.key === 'shipmentValue'"
                class="ibc-body-text-medium"
                tabindex="-1"
                (keydown)="$event.stopPropagation()">
                {{ element.shipmentValueMin }} - {{ element.shipmentValueMax }}
              </span>
              <span
                *ngIf="item.key === 'shipmentWeight'"
                class="ibc-body-text-medium"
                tabindex="-1"
                (keydown)="$event.stopPropagation()">
                {{ element.shipmentWeightMin }} - {{ element.shipmentWeightMax }}
              </span>
            </ng-template>  
          }
        </mat-cell>
      </ng-container>
    </form>

    <!-- Action column -->
    <ng-container matColumnDef="action">
      <mat-header-cell *matHeaderCellDef>
        <span class="ibc-body-text-large">Actions</span>
      </mat-header-cell>
      <ng-container>
        <mat-cell *matCellDef="let element; let i = index">
          <span
            [attr.aria-hidden]="true"
            *ngIf="!element.isInputRow"
            class="ibc-body-text-medium text-hyperlink cursor"
            (click)="navigateToInformationPage(element, i, 'view', false)"
            (keydown)="$event.stopPropagation()"
            >Details</span
          >
        </mat-cell>
      </ng-container>
    </ng-container>
  </mat-table>
</div>
